/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState, useEffect } from "react";
import AuthContext from '../../context/auth-context'
import { Row, Col } from 'react-bootstrap';
import { Container, Button, Table, TableBody, TableCell, TableHead, TablePagination, TableRow, TableSortLabel, Paper, FormControlLabel, Switch } from '@material-ui/core';
import { FaChevronLeft } from 'react-icons/fa';
import PropTypes from "prop-types";
import useStyles from '../../css/useStylesTabel'
import LoyaltyIcon from '@material-ui/icons/Loyalty';
import mControl from './Promo.Controler'
import TouchAppIcon from '@material-ui/icons/TouchApp';
import moment from 'moment'
import numberWithCommas from '../../Helper/numberWithCommas'
import Dropdown from 'react-bootstrap/Dropdown'
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import ModalPromo from './Modal.AddPromo'
import { isArray } from 'util';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';



const desc = (a, b, orderBy) => {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

const stableSort = (array, cmp) => {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

const getSorting = (order, orderBy) => {
    return order === "desc"
        ? (a, b) => desc(a, b, orderBy)
        : (a, b) => -desc(a, b, orderBy);
}

const headRows = [
    { id: "kodePromo", label: "Kode Promo" },
    { id: "namaPromo", label: "Nama Promo" },
    { id: "tanggalMulai", label: "Tanggal Mulai" },
    { id: "tanggalSelesai", label: "Tanggal Selesai" },
    { id: "minimumPurchase", label: "Minimun Pembelian" },
    { id: "discountPercent", label: "Diskon Persen" },
    { id: "discountAmount", label: "Jumlah Diskon" },
    { id: "maxDiscountAmount", label: "Maksimal Jumlah Diskon" },
    { id: "isHide", numeric: true, label: "Aktif" },
];

const EnhancedTableHead = (props) => {
    const {
        classes,
        order,
        orderBy,
        onRequestSort
    } = props;
    const createSortHandler = property => event => {
        onRequestSort(event, property);
    };
    return (
        <TableHead>
            <TableRow>
                <TableCell>Action</TableCell>
                {headRows.map(row => (
                    <TableCell key={row.id}>
                        <TableSortLabel
                            active={orderBy === row.id}
                            direction={order}
                            onClick={createSortHandler(row.id)}
                        >
                            {row.label}
                            {orderBy === row.id ? (
                                <span className={classes.visuallyHidden}>
                                    {order === "desc" ? "sorted descending" : "sorted ascending"}
                                </span>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.oneOf(["asc", "desc"]).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired
};

const RiwayatTransaksi = (props) => {
    const kodeoutlet = props.match.params.kodeoutlet;
    const defaultPage = (props.match.params.page - 1) * 1;
    const defaultrowsPerPage = props.match.params.rowsPerPage * 1;
    const { clientID, token } = useContext(AuthContext)
    const classes = useStyles();
    const [order, setOrder] = React.useState("asc");
    const [orderBy, setOrderBy] = React.useState("namabarang");
    const [page, setPage] = React.useState(defaultPage);
    const [rowsPerPage, setRowsPerPage] = React.useState(defaultrowsPerPage);
    const [dense, setDense] = React.useState(true);
    const [isRefresh, setIsRefresh] = useState(true)
    const [rows, setRows] = useState([])
    const [dataDialog, setDataDialog] = useState({})
    const [isModal, setIsModal] = useState(false)
    const goBack = () => {
        props.history.push(`/manajemenoutlet/${kodeoutlet}`)
    }
    const handleRequestSort = (event, property) => {
        const isDesc = orderBy === property && order === "desc";
        setOrder(isDesc ? "asc" : "desc");
        setOrderBy(property);
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    }

    const handleChangeDense = (event) => {
        setDense(event.target.checked);
    }
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);
    useEffect(() => {
        mControl.loadData(kodeoutlet, clientID, token).then(resp => {
            setRows(resp);
        }).catch(err => {
            console.error(err);
        }).finally(() => setIsRefresh(false))
        return () => {

        }
    }, [isRefresh])
    const handleAdd = () => {
        setDataDialog({})
        setIsModal(true)
    }
    const handleDelete = (data) => {
        const oke = window.confirm(`Yakin ingin hapus Promo ini?`)
        if (oke) {
            mControl.hapusPromo(kodeoutlet, clientID, token, data.kodePromo).then(resp => {
                if (resp) {
                    alert("Berhasil di hapus")
                    setIsRefresh(true)
                } else {
                    alert("Gagal Di hapus")
                }
            }).catch(err => {
                if (isArray(err) && err.length > 0) {
                    alert(`${err[0].message}`)
                } else if (typeof err) {
                    alert(err.message)
                } else {
                    console.log(err);
                }
            })
        }
    }
    const handleEdit = (data) => {
        setDataDialog(data)
        setIsModal(true)
    }
    const handleActive = (data) => {
        let aktif = false
        if (data.isHide) aktif = data.isHide
        mControl.handleActive(kodeoutlet, data.kodePromo, clientID, token, !aktif).then(resp => {
            if (resp) {
                alert(`Promo berhasil di ${aktif ? ("activated ") : ("deactivated")}`)
                setIsRefresh(true)
            } else {
                alert(`Server tidak dapat memenuhi permintaan Anda saat ini. Harap coba beberapa saat lagi`)
            }
        }).catch(err => {
            if (isArray(err) && err.length > 0) {
                alert(`Gagal hapus ${err[0].message}`)
            } else if (typeof err == 'error') {
                alert(`${err.message}`)
            } else {
                console.log(err);
            }
        });
    }
    return (
        <Container>
            <Row>
                <Col xs={12}>
                    <h3 style={{ marginTop: 20, paddingBottom: 10 }} className="border-bottom"><FaChevronLeft onClick={goBack.bind(this)} className="btnBack" />List Promo</h3>
                    <Button variant="contained" color="primary" onClick={handleAdd} ><LoyaltyIcon />Add Promo</Button>
                </Col>
                <Col xs={12}>
                    <div className={classes.root}>
                        <Paper className={classes.paper}>
                            <div className="btnTable">
                            </div>
                            <div className={classes.tableWrapper}>
                                <Table
                                    className={classes.table}
                                    aria-labelledby="tableTitle"
                                    size={dense ? "small" : "medium"}
                                >
                                    <EnhancedTableHead
                                        classes={classes}
                                        order={order}
                                        orderBy={orderBy}
                                        onRequestSort={handleRequestSort}
                                        rowCount={rows.length}
                                    />
                                    <TableBody>

                                        {stableSort(rows, getSorting(order, orderBy))
                                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                            .map((row, index) => {
                                                return (
                                                    <TableRow
                                                        hover
                                                        role="checkbox"
                                                        tabIndex={-1}
                                                        key={index}
                                                        className={(row.statusid === 8 || row.statusid === 9) && ("bgRowCancel") || ("")}
                                                    >
                                                        <TableCell>
                                                            <Dropdown>
                                                                <Dropdown.Toggle variant="success" id="dropdown-basic">
                                                                    <TouchAppIcon id="dropdown-basic" /></Dropdown.Toggle>
                                                                <Dropdown.Menu>
                                                                    <Dropdown.Item><Button title="Edit" variant="contained" style={{ backgroundColor: '#376275', marginRight: 10, color: "#fff", width: '135px' }} onClick={handleEdit.bind(this, row)}><EditIcon /> Edit/lihat</Button></Dropdown.Item>
                                                                    <Dropdown.Item><Button title="Hapus" variant="contained" style={{ backgroundColor: 'red', marginRight: 10, color: "#fff", width: '135px' }} onClick={handleDelete.bind(this, row)}><DeleteIcon /> Hapus</Button></Dropdown.Item>
                                                                    <Dropdown.Item><Button title="Hapus" variant="contained" style={{ backgroundColor: '#588c4b', marginRight: 10, color: "#fff", width: '135px' }} onClick={handleActive.bind(this, row)}> {row.isHide ? ("Activated") : ("Deactivated")}</Button></Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </TableCell>
                                                        <TableCell >
                                                            {row.kodePromo}
                                                        </TableCell>
                                                        <TableCell>
                                                            {row.namaPromo}
                                                        </TableCell>
                                                        <TableCell>
                                                            {moment(row.tanggalMulai).format("DD-MM-YYYY")}
                                                        </TableCell>
                                                        <TableCell>
                                                            {moment(row.tanggalSelesai).format("DD-MM-YYYY")}
                                                        </TableCell>
                                                        <TableCell className="text-right">
                                                            {numberWithCommas(row.minimumPurchase)}
                                                        </TableCell>
                                                        <TableCell className="text-center">
                                                            {row.discountPercent || 0}
                                                        </TableCell>
                                                        <TableCell className="text-right">
                                                            {numberWithCommas(row.discountAmount)}
                                                        </TableCell>
                                                        <TableCell className="text-right">
                                                            {numberWithCommas(row.maxDiscountAmount)}
                                                        </TableCell>
                                                        <TableCell>
                                                            {row.isHide ? <CloseIcon /> : <CheckIcon />}
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })}
                                        {emptyRows > 0 && (
                                            <TableRow style={{ height: 49 * emptyRows }}>
                                                <TableCell colSpan={9} />
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </div>
                            <TablePagination
                                rowsPerPageOptions={[5, 10, 25, 50, 100]}
                                component="div"
                                count={rows.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                backIconButtonProps={{
                                    "aria-label": "previous page"
                                }}
                                nextIconButtonProps={{
                                    "aria-label": "next page"
                                }}
                                onChangePage={handleChangePage}
                                onChangeRowsPerPage={handleChangeRowsPerPage}
                            />
                        </Paper>
                        <FormControlLabel
                            control={<Switch checked={dense} onChange={handleChangeDense} />}
                            label="Dense padding"
                        />
                    </div>
                </Col>
            </Row>
            {isModal && (
                <ModalPromo open={isModal} setOpen={setIsModal} kodeoutlet={kodeoutlet} clientID={clientID} token={token} dataDialog={dataDialog} setIsRefresh={setIsRefresh} />
            )}
        </Container>
    );
}
export default RiwayatTransaksi;